export default "__VITE_ASSET__BSPdxJKX__"